<template>
  <small :style="`color: ${calculatedColor}`" class="tiny">
    <slot></slot>
  </small>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: false,
    },
  },
  computed: {
    calculatedColor() {
      const getColor = () => {
        const isCurrentColor = this.color === 'currentcolor';
        const isGray = this.color === 'gray';
        const isWhite = this.color === 'white';

        if (isCurrentColor) return 'currentcolor';
        if (isWhite) return 'var(--gray-0)';
        if (isGray) return 'var(--gray-800)';
        return 'var(--gray-900)';
      };

      return getColor();
    },
  },
};
</script>

<style scoped>
.tiny {
  display: block;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 12px;
  font-family: var(--font-family-sans);
  font-weight: 400;
  line-height: 18px;
  text-align: left !important; /* NOTE @chris Global leak. */
}
.tiny b {
  font-weight: 700;
}
</style>
